import { observer } from "mobx-react";

import DefaultUploader from "../default/default";
import type { UploaderProps } from "../default/default";

const Uploader = (props: UploaderProps) => {
    const {
        uploaderStore,
        name,
        footerText,
        defaultPreviewOptions,
        footerTooltipText,
        displayErrorMsg,
        isSquare = false,
        width = "200px",
        height = "110px",
        maxUploadSizeAllowed
    } = props;

    return (
        <DefaultUploader
            uploaderStore={uploaderStore}
            name={name}
            footerText={footerText}
            defaultPreviewOptions={defaultPreviewOptions}
            isCompact
            isSquare={isSquare}
            footerTooltipText={footerTooltipText}
            displayErrorMsg={displayErrorMsg}
            width={width}
            height={height}
            maxUploadSizeAllowed={maxUploadSizeAllowed}
        />
    );
};

export default observer(Uploader);
